spec_version: '1.1'
id: 4
slug: 04-ahorro-automatizado
titulo: Ahorro automatizado
duracion_min: 90
estado: placeholder
fase_produccion: 0
ultima_actualizacion: '2026-06-15'
prerrequisitos: []
objetivos_aprendizaje:
- id: OA-04.1
  texto: Implementar un sistema de ahorro automatizado en tu banco
  bloom: ''
- id: OA-04.2
  texto: Definir y revisar tu tasa de ahorro de forma sostenida
  bloom: ''
- id: OA-04.3
  texto: Ajustar el sistema cuando cambia tu situación de ingresos
  bloom: ''
glosario: []
secciones:
- tipo: teoria
  archivo: teoria.md
- tipo: quiz-practica
  archivo: quiz-practica.md
- tipo: recursos
  archivo: recursos.md
sub_secciones_teoria:
- id: '4.1'
  titulo: 'Pay yourself first: el principio operativo'
  duracion_min: 15
- id: '4.2'
  titulo: Definir tu tasa de ahorro objetivo
  duracion_min: 15
- id: '4.3'
  titulo: Domiciliación y reglas automáticas del banco
  duracion_min: 15
- id: '4.4'
  titulo: Separar cuentas por propósito
  duracion_min: 15
- id: '4.5'
  titulo: Revisión trimestral del sistema
  duracion_min: 15
- id: '4.6'
  titulo: Cómo reaccionar cuando los ingresos suben o bajan
  duracion_min: 15
